import { createContext, type FC } from 'react';

import type { NoteEditorBlockKind } from '../../config';

export type NoteBlockWidget = FC<{ blockId: string }>;

export type NoteLineWidget = FC<{ lineId: string }>;

// The widgets the note's document hosts. The layer that owns them hands
// them in, so the editor never imports the note's widgets.
export type NoteBlockWidgets = {
  // A value block's widget by its kind.
  byKind: Partial<Record<NoteEditorBlockKind, NoteBlockWidget>>;
  // A block of a kind without a widget, or without a definition.
  fallback: NoteBlockWidget;
  // The marks and actions of a text block, right after its text.
  aside?: NoteBlockWidget;
  // A line shown by a widget of its own.
  line?: NoteLineWidget;
  // What a line shows before and after its text, as its controls.
  lineLead?: NoteLineWidget;
  lineTail?: NoteLineWidget;
};

export const NoteBlockWidgetsContext = createContext<NoteBlockWidgets | null>(
  null,
);
